/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Stats_Tab_CheckInputs */

const vi_lot_stats_tab_check = /** @type {(inputs: Lot_Stats_Tab_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chốt sổ`)
};

/**

* @param {Lot_Stats_Tab_CheckInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_stats_tab_check = /** @type {((inputs?: Lot_Stats_Tab_CheckInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Stats_Tab_CheckInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_stats_tab_check(inputs)
});